import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Slug',
  props: {
    slug: null,
    slugHistory: null
  },
  emits: ["update:slug", "update:slugHistory"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:slug', slug: string): void;
  (e: 'update:slugHistory', slugHistory: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  slug?: string;
  slugHistory?: string[];
}



const initialSlug = props.slug;

const slug = ref(props.slug || '');
const slugHistory = ref(props.slugHistory || []);

const newUrl = ref('');
const panel = ref([]);



const removeFromHistory = (url?: string) => {
  if (!url) {
    return;
  }

  slugHistory.value = slugHistory.value.filter((u) => u !== url);
  emits('update:slugHistory', slugHistory.value);
};
const addToHistory = (url?: string) => {
  if (!url || slugHistory.value.includes(url)) {
    return;
  }
  slugHistory.value.push(url);
  emits('update:slugHistory', slugHistory.value);
  newUrl.value = '';
};

watch(
  // catch the slug generation from the parent
  () => props.slug,
  () => {
    slug.value = props.slug || '';
  },
);
watch(slug, () => {
  emits('update:slug', slug.value);
  if (slug.value === initialSlug) {
    removeFromHistory(initialSlug);
    return;
  }
  addToHistory(initialSlug);
});
watch(
  slugHistory,
  (newHistory) => {
    emits('update:slugHistory', newHistory);
  },
  { deep: true },
);

return { __sfc: true,props, initialSlug, slug, slugHistory, newUrl, panel, emits, removeFromHistory, addToHistory }
}

})